export const SKU_DETAILS_MESSAGES = {
  "PT-BR": {
    title: "Detalhes do SKU",
    subtitle: "Informações detalhadas do produto",
    sku_code: "Código SKU",
    product_name: "Nome do Produto",
    description: "Descrição",
    price: "Preço",
    stock: "Estoque",
    weight: "Peso",
    dimensions: "Dimensões",
    status: "Status",
    created_at: "Criado em",
    updated_at: "Atualizado em",
    actions: "Ações",
    edit: "Editar",
    delete: "Excluir",
    back_to_product: "Voltar ao Produto",
    loading: "Carregando...",
    error_loading: "Erro ao carregar SKU",
    delete_confirm: "Tem certeza que deseja excluir este SKU?",
    delete_success: "SKU excluído com sucesso",
    delete_error: "Erro ao excluir SKU",
  },
  "EN-US": {
    title: "SKU Details",
    subtitle: "Detailed product information",
    sku_code: "SKU Code",
    product_name: "Product Name",
    description: "Description",
    price: "Price",
    stock: "Stock",
    weight: "Weight",
    dimensions: "Dimensions",
    status: "Status",
    created_at: "Created at",
    updated_at: "Updated at",
    actions: "Actions",
    edit: "Edit",
    delete: "Delete",
    back_to_product: "Back to Product",
    loading: "Loading...",
    error_loading: "Error loading SKU",
    delete_confirm: "Are you sure you want to delete this SKU?",
    delete_success: "SKU deleted successfully",
    delete_error: "Error deleting SKU",
  },
};
